import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider, useSite } from "@/context/SiteContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AnnouncementBar from "@/components/AnnouncementBar";
import FloatingChatbot from "@/components/FloatingChatbot";
import SplashLoader from "@/components/SplashLoader";
import OfflineOverlay from "@/components/offline/OfflineOverlay";
import ScrollToTop from "@/components/ScrollToTop";
import ExternalRedirect from "@/components/ExternalRedirect";
import Home from "@/pages/Home";
import ScrapRates from "@/pages/ScrapRates";
import Kabadiwalas from "@/pages/Kabadiwalas";
import News from "@/pages/News";
import Learn from "@/pages/Learn";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function PublicLayout() {
  return (
    <div className="App min-h-screen flex flex-col">
      <AnnouncementBar />
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <FloatingChatbot />
    </div>
  );
}

const CONSUMER_PATHS = ["/login", "/register", "/pickup", "/dashboard", "/wallet", "/book"];
const PARTNER_PATHS = ["/partner", "/partner-dashboard", "/partner/*"];
const RETIRED_PATHS = ["/store", "/hubs", "/leaderboard", "/brands", "/brands/*", "/brand", "/refer", "/impact/*", "/verify/*", "/addresses", "/support"];

function LangKeyed({ children }) {
  const { lang } = useSite();
  return <div key={lang}>{children}</div>;
}

export default function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <AdminAuthProvider>
          <ScrollToTop />
          <SplashLoader />
          <LangKeyed>
          <OfflineOverlay />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/scrap-rates" element={<ScrapRates />} />
              <Route path="/kabadiwalas" element={<Kabadiwalas />} />
              <Route path="/news" element={<News />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/academy" element={<Navigate to="/learn" replace />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              {RETIRED_PATHS.map((p) => <Route key={p} path={p} element={<Navigate to="/" replace />} />)}
              <Route path="*" element={<NotFound />} />
            </Route>
            {CONSUMER_PATHS.map((p) => <Route key={p} path={p} element={<ExternalRedirect target="consumer" />} />)}
            {PARTNER_PATHS.map((p) => <Route key={p} path={p} element={<ExternalRedirect target="partner" />} />)}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          </LangKeyed>
          <Toaster richColors position="top-center" />
        </AdminAuthProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}
